// QueryClient compartido para todo el frontend.
// Piloto de @tanstack/react-query (ver memoria project-react-query-pilot).
// Las llamadas HTTP siguen pasando por src/api/common.js — RQ solo cachea.

import { QueryClient } from '@tanstack/react-query';

// Defaults conservadores: priorizar predictibilidad sobre frescura.
// Cada useQuery puede sobrescribir (ej: cuentas externas usa staleTime de 1h).
const defaultOptions = {
  queries: {
    staleTime: 5 * 60 * 1000,            // 5 min cache "fresca" antes de refetch en background
    gcTime: 10 * 60 * 1000,              // 10 min antes de eliminar de memoria
    retry: 1,                            // un reintento; no loops si el backend cae
    refetchOnWindowFocus: false,         // evitar refetch al cambiar de pestaña (UX biolab)
    refetchOnReconnect: 'always'
  },
  mutations: {
    retry: 0
  }
};

export const queryClient = new QueryClient({ defaultOptions });

